export let dnyamicLangWords = {};

export function setDynamicWords(words) {
  if (words) {
    dnyamicLangWords = words;
    //  console.log(dnyamicLangWords);
  }
}



// WEBPACK FOOTER //
// ./src/Language/DynamicLanguage.js